import { logout } from "../../auth/login/Auth";
import { LocalStorage } from "../../util/Utils";

export const requestConfig = (config: any) => {
  let userToken = sessionStorage.getItem("user-token");
  if (!userToken) {
    userToken = LocalStorage.get("user-token");
  }
  if (userToken) {
    config.headers["Authorization"] = `Bearer ${userToken}`;
  }
  if (config.url.includes("export") || config.url.includes("download")) {
    config["responseType"] = "blob";
  }
  if (config.url.includes("importExcel") || config.url.includes("upload") || config.url.includes("import")) {
    config.headers["Content-Type"] = `multipart/form-data`;
  }
  return config;
};

export const responseConfig = (response: any) => {
  if (response.status !== 200) {
    return response.data.errors?.toString();
  }
  return response;
};

export const requestErrorHandler = (error: any) => {
  // custom code goes here
  return Promise.reject(error);
};

export const responseErrorHandler = (error: any) => {
  const convertBlobToText = async (blob: any) => {
    return await blob.text(blob);
  };

  if (error.response.status === 401) {
    LocalStorage.append("unauthorized", true);
    if (error.response.data?.message === "Token Expired") {
      logout();
    }
  }
  if (error.response.status !== 200) {
    if (error.response.data instanceof Blob)
      return convertBlobToText(error.response.data);

    return error.response.data.errors.toString();
  }

  //return Promise.reject(error); //need this line of code for future ref
};
